<template>
  <div>
    <div class="sa-mob-cont sa-mob-cont-padbt">
      <button class="sa-btn-back" @click="$parent.referNurse = false">
        <i class="icon-arrow-left"></i>
      </button>
      <div class="sa-row sa-d-f-a-center">
        <div class="sa-col-xs12 sa-col-sm7 sa-col-md7 sa-col-lg8">
          <h5 class="sa-card-tit sa-ref-tit">Refer to nurse</h5>
        </div>
        <div class="sa-col-xs12 sa-col-sm5 sa-col-md5 sa-col-lg4">
          <div class="sa-form-group">
            <input
              v-model="searchName"
              @input="getTasks"
              type="text"
              class="sa-form-control sa-search-lft"
              id="ReferNurse"
              name="Refer to nurse"
              placeholder="Search Tasks"
            /><i class="icon-search sa-search-icn"></i>
          </div>
        </div>
      </div>
      <ul v-if="tasks && tasks.length" class="sa-nurse-list">
        <li v-for="(t, i) in tasks" :key="i">
          <input
            type="checkbox"
            :value="t.tsk_id"
            :id="t.tsk_id"
            v-model="tsk_id"
            :name="t.tsk_id"
          />
          <label :for="t.tsk_id">
            <figure class="sa-avtar sa-avtar-lg">
              <img
                src="https://img.litedev.com/images/unknown-avtar.png"
                alt="Doctor"
                class="sa-img-cover"
              />
            </figure>
            <span class="sa-nurse-cnt"
              ><strong>{{ t.tsk_nm }}</strong
              ><small
                v-for="(inc, i) in t.inclsn"
                :key="i"
                class="sa-d-block"
                >{{ inc }}</small
              ></span
            >
          </label>
        </li>
      </ul>
      <ul v-else class="sa-nurse-list">
        <li>
          <span>No tasks found</span>
        </li>
      </ul>
    </div>
    <div class="sa-mt40 sa-ftr-btn">
      <button
        :disabled="loader"
        @click="referNurse"
        class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs"
      >
        Continue
      </button>
    </div>
    <div v-if="loading">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
  methods: {
    getTasks() {
      this.loading = true;
      let _self = this;
      _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/treatmentDetails`,
          body: {
            mtype: 4,
            limit: 1000,
            page: 1,
            name: _self.searchName,
            prd_id: "ST03",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.tasks = response.data.data;
          }
        });
    },
    referNurse() {
      this.loading = true;
      let _self = this;
      _self.patDetails = JSON.parse(_self.$localStorage.get("patDetails"));
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/refer/addTreatmentReferal`,
          body: {
            apnt_id: _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            uid: _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || "",
            dept_id: _self.patDetails.dept_id || "",
            pkg_id: _self.patDetails.refPackages || [],
            tsk_id: _self.tsk_id,
            tst_id: _self.patDetails.refTests || [],
            trtmnt_id: _self.patDetails.refPhysio || [],
            ref_doctorId: _self.patDetails.ref_doctorId || "",
          },
        })
        .then((response) => {
          _self.loading = false;
          if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Referred Nurse Tasks successfully",
              class: "sa-a-success",
            });
            _self.patDetails.refNurse = _self.tsk_id;
            _self.$localStorage.set(
              "patDetails",
              JSON.stringify(_self.patDetails)
            );
            _self.$parent.referNurse = false;
            _self.$parent.getReferralData();
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
              class: "sa-a-danger",
            });
          }
        });
    },
  },
  mounted() {
    this.getTasks();
  },
  props: ["tsk_id"],
  data() {
    return {
      loader: false,
      loading: false,
      checked: false,
      tasks: null,
      searchName: "",
    };
  },
};
</script>